import React from 'react'
import Component from '../common/Component'
import LargeGroupCustomBenefitsSetComponent from './LargeGroupCustomBenefitsSetComponent'
import { benefitNames } from './fields'
import BenefitsSetForm from '../BenefitsSet/BenefitsSetForm'

export default class LargeGroupCustomBenefitsSetForm extends Component {
  render() {
    return (
      <BenefitsSetForm
        benefitNames={benefitNames}
        benefitsSetComponent={LargeGroupCustomBenefitsSetComponent}
        productLine="Medical"
        {...this.props}
      />
    )
  }
}
